export const MIGRATION = 'migration'
export const MAJOR_ACCOUNT_CHANGE = 'major_account_change'
export const NEW_APPLICATION = 'new'
export const ADVANCED_ONBOARDING = 'advancedOnboarding'

// Keys used in local storage
export const AUTH_STORAGE_TOKEN_KEY = 'logged_in_user_token'
export const APPLICANT_EMAIL_HASH_KEY = 'applicant_email_hash'
export const APPLICANT_EMAIL_KEY = 'applicant_email_key'
export const APPLICANT_AUTH_ID = 'applicant_auth_id'
export const SALESFORCE_CREDIT_IDS = 'salesforce_credit_ids'
export const APPLICANT_DATA_FROM_UP = 'applicant_data_from_up'
export const LT_LANDING_PAGE = 'lt_landing_page'

export const LOCAL_STORAGE_KEYS = {
  APPLICANT_AUTH_ID,
  APPLICANT_EMAIL_KEY,
  APPLICANT_EMAIL_HASH_KEY,
  AUTH_STORAGE_TOKEN_KEY,
  SALESFORCE_CREDIT_IDS,
  APPLICANT_DATA_FROM_UP,
  LT_LANDING_PAGE,
}

/* When using these, implement by destructuring the values inside the object */
/* example: const { BILL_SPEND_AND_EXPENSE, BILL_DIVVY_CARD, BILL_DIVVY_RESERVE_CARD, BILL, DIVVY_PAY_LLC } = PRODUCT_CONST_STRINGS */
export const PRODUCT_CONST_STRINGS = {
  BILL_SPEND_AND_EXPENSE: 'BILL Spend & Expense',
  BILL_DIVVY_CARD: 'BILL Divvy Card',
  BILL: 'BILL',
  DIVVY_PAY_LLC: 'DIVVY PAY LLC',
}

export const PATHNAME_CONSTS = {
  // legacy (v2) routes
  AUTH_PATH: '/auth',
  VERIFY_EMAIL_PATH: '/verify-email',
  VERIFY_CODE_PATH: '/verify-code',
  SUBMISSION_ERROR_PATH: 'submission-error',
  SUBMITTING_APPLICATION: 'submitting-application',

  // v3 app routes
  DASHBOARD_PATH: '/dashboard',
  DASHBOARD_PATH_DETAILS_DRAWER: 'details',
  DASHBOARD_PATH_DOCUMENTS_DRAWER: 'documents',

  /* pre application routes */
  AUTH_PATH_ABSOLUTE: 'auth',
  MIGRATION_PATH_ABSOLUTE: 'migration', // do we need for v3?
  BDC_LANDING_PATH: '/bdc-landing',
  VERIFY_PATH: 'verify',
  POST_LOGIN_PATH: 'login-success',
  GOOD_FIT_SURVEY_PATH: '/survey',
  GOOD_FIT_RESULT_PATH: 'good-fit',
  NOT_GOOD_FIT_RESULT_PATH: 'not-good-fit',
  GET_TO_KNOW_YOU: '/get-to-know',

  /* credit application form routes */
  NAME_AND_OWNERSHIP_PATH: 'name-and-ownership',
  BUSINESS_ADDRESS_PATH: 'business-address',
  FINANCIAL_DETAILS_PATH: 'financial-details',
  CONNECT_BANK_ACCOUNT_PATH: 'connect-bank-account',
  PEOPLE_INFO_PATH: 'people-info',
  REVIEW_PATH: 'review',

  /* after app submission routes */
  NO_OFFER_PATH: 'no-offer',
  OFFERS_PATH: 'offers',
  STANDARD_CREDIT_LINE_PATH: 'standard-credit-line',
  VARIABLE_CREDIT_LINE_PATH: 'variable-credit-line',
  PREPAY_OFFER_PATH: 'prepay',
  ACCEPTING_OFFER: 'accepting-offer',
  OFFER_ACCEPTED_PATH: 'accepted',
  FROZEN_CREDIT_PATH: 'frozen-credit',
  WORKING_OUT_DETAILS_PATH: 'working-out-details',
  MIGRATION_SUCCESS_PATH: 'success',
}

const baseWebAssetsPdfPath = 'https://app.divvy.co/assets/pdfs/bill_divvy_signup_application_'

export const URL = {
  APP_PROD: 'apply.divvy.co',
  BILL_PRIVACY_NOTICE: 'https://www.bill.com/privacy',
  BILL_REWARDS_LINK: 'http://bill.com/product/rewards',
  BILL_REWARDS_TERMS: 'https://www.bill.com/legal/bill-rewards-program',
  BILL_AP_AR: 'https://www.bill.com/product/accounts-payable',
  BILL_TERMS_AND_CONDITIONS: 'https://www.bill.com/legal/spend-expense-terms-of-service',
  CREDIT_IMPACT_LEARN_MORE: 'https://help.getdivvy.com/en/articles/5043115-divvy-credit-application-faq#h_8ce5a44308',
  ELIGIBILITY_REQUIREMENTS_LINK:
    'https://help.getdivvy.com/en/articles/6282738-what-are-the-eligibility-requirements-for-divvy-s-credit-application',
  DIVVY_PROD: 'https://app.divvy.co',
  DIVVY_PROD_PASSWORD_SETUP: 'https://app.divvy.co/setup/password',

  // DSA TERMS
  DSA_TERMS_WEX_BO: `${baseWebAssetsPdfPath}dsa_wex_bo.pdf`,
  DSA_TERMS_WEX_JS: `${baseWebAssetsPdfPath}dsa_wex_js.pdf`,
  DSA_TERMS_CRB_BO: `${baseWebAssetsPdfPath}dsa_crb_bo.pdf`,
  DSA_TERMS_CRB_JS: `${baseWebAssetsPdfPath}dsa_crb_js.pdf`,
  DSA_TERMS_WEBBANK_PG: `${baseWebAssetsPdfPath}dsa_web_bank_pg.pdf`,
  DSA_TERMS_WEBBANK_BO: `${baseWebAssetsPdfPath}dsa_web_bank_bo.pdf`,

  GOOGLE_TERMS_OF_SERVICE: 'https://policies.google.com/terms',
  GOOGLE_PRIVACY_POLICY: 'https://policies.google.com/privacy',
  STANDARD_LINE_OFFER_LEARN_MORE_LINK: 'https://help.bill.com/direct/s/article/000003577',
  VARIABLE_LINE_OFFER_LEARN_MORE_LINK: 'https://help.bill.com/direct/s/article/6702952',
  PREPAY_OFFER_LEARN_MORE_LINK: 'https://help.bill.com/direct/s/article/000003645',
  EXPERIAN_FREEZE_CENTER: 'https://www.experian.com/freeze/center.html',
  EXPERIAN_LEARN_MORE: 'http://help.getdivvy.com/en/articles/6156143',
  BILL_HELP_CENTER_LINK: 'https://help.bill.com/direct/s/',
  BILL_LEGAL_LINK: 'https://www.bill.com/legal/',
  BILL_SECURITY_LINK: 'https://www.bill.com/product/security',
}

export const EDITABLE_STATUSES = ['AWAITING_SIGNATURE', 'IN_PROGRESS', 'CORRECTION_REQUESTED', 'NOT_STARTED']

// add more types as they are needed
export const DSA_VERSION_TYPES = {
  CRB_B_O: 'crb_business_only',
  CRB_MC_B_O: 'crb_mc_business_only',
  CRB_MC_J_S: 'crb_mc_j_s',
  WEX_B_O: 'wex_business_only',
  WEB_BANK_PG: 'web_bank_pg',
  WEB_BANK_B_O: 'web_bank_business_only',
}
